/**
 * Equipment Express — Variant Price Sync
 * Keeps the visible product price in sync with Empire's <variant-selection>
 * custom element on product pages, featured products, and Quick Shop.
 */
(function () {
  'use strict';

  var SCRIPT_SELECTOR = 'script[data-ee-variant-price-sync]';
  var attached = new WeakSet();

  function getMoneyFormat() {
    var script = document.querySelector(SCRIPT_SELECTOR);
    return script && script.dataset.eeMoneyFormat
      ? script.dataset.eeMoneyFormat
      : '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents || 0, getMoneyFormat());
    }

    var amount = Number(cents || 0) / 100;
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function getProductWrapper(selection) {
    return selection.closest('[data-product-wrapper]') ||
      selection.closest('[data-product-details]') ||
      selection.closest('.product--outer') ||
      selection.parentElement;
  }

  function updateVisiblePrice(selection, variant) {
    if (!variant) return;

    var wrapper = getProductWrapper(selection);
    if (!wrapper) return;

    var pricing = wrapper.querySelector('[data-product-pricing]');
    if (!pricing) return; // Quote-only / no-price templates intentionally have no price block.

    var priceContainer = pricing.querySelector('[data-price-container]');
    var priceMoney = priceContainer && priceContainer.querySelector('[data-price]');
    if (priceMoney) {
      priceMoney.innerHTML = formatMoney(variant.price);
    }

    var compareContainer = pricing.querySelector('[data-price-compare-container]');
    var compareMoney = compareContainer && compareContainer.querySelector('[data-price-compare]');
    var isOnSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);

    if (compareContainer) {
      compareContainer.classList.toggle('visible', isOnSale);
      compareContainer.setAttribute('aria-hidden', isOnSale ? 'false' : 'true');
    }

    if (compareMoney && isOnSale) {
      compareMoney.innerHTML = formatMoney(variant.compare_at_price);
    }

    if (priceContainer) {
      priceContainer.classList.toggle('price__current--on-sale', isOnSale);
    }

    // Keep any duplicate visible price nodes in the same product-pricing block synchronized.
    pricing.querySelectorAll('[data-price]').forEach(function (node) {
      if (node.closest('[data-current-price-hidden]') || node.closest('[data-current-price-range-hidden]')) {
        return;
      }
      node.innerHTML = formatMoney(variant.price);
    });
  }

  function attach(selection) {
    if (!selection || attached.has(selection)) return;
    attached.add(selection);

    selection.addEventListener('variant-change', function (event) {
      if (!event.detail) return;
      updateVisiblePrice(selection, event.detail.variant);
    });
  }

  function scan(root) {
    if (!root) return;

    if (root.matches && root.matches('variant-selection[data-variant-selection]')) {
      attach(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('variant-selection[data-variant-selection]').forEach(attach);
    }
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
